var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { Icon, Stepper, useStepper } from "@opala-ds/react";
import { FormProvider, useFieldArray, useForm, } from "react-hook-form";
import { z } from "zod";
import { useEffect } from "react";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import useCollectiveModalityStore from "../../../../stores/collectiveModalityStore";
import { ImageFileSchema, RequiredStringSchema, } from "../../../../utils/schemas";
import FileInput from "../../../FileInput";
import FormActions from "../../FormActions";
import AthleteFields from "./AthleteFields";
/**
 * ---------------------------------------------------------------------
 * Schema ----------------------------------------------------------------
 * ---------------------------------------------------------------------
 */
var alunos_atletasSchema = z.object({
    cpf: RequiredStringSchema,
    rg: RequiredStringSchema,
    nome: RequiredStringSchema,
    data_nascimento: RequiredStringSchema,
    foto_arquivo: ImageFileSchema,
});
var Schema = z.object({
    /**
     * A comissão técnica precisa ter pelo menos 1 Assistente técnico,
     * mas o usuário pode adicionar quantos forem necessários.
     */
    alunos_atletas: z.array(alunos_atletasSchema).min(1),
});
export default function AthleteDataForm(_a) {
    var _this = this;
    var onSubmit = _a.onSubmit, _b = _a.defaultValues, defaultValues = _b === void 0 ? {
        alunos_atletas: [
            {
                cpf: "",
                rg: "",
                nome: "",
                data_nascimento: "",
                foto_arquivo: undefined,
            },
        ],
    } : _b;
    /**
     * -------------------------------------------------------------------
     * React‑Hook‑Form setup ---------------------------------------------
     * -------------------------------------------------------------------
     */
    var _c = useForm({
        defaultValues: defaultValues,
        resolver: zodResolver(Schema),
    }), watch = _c.watch, handleSubmit = _c.handleSubmit, register = _c.register, control = _c.control, _d = _c.formState, errors = _d.errors, formStateRest = __rest(_d, ["errors"]), formRest = __rest(_c, ["watch", "handleSubmit", "register", "control", "formState"]);
    var _e = useFieldArray({
        control: control,
        name: "alunos_atletas",
    }), fields = _e.fields, append = _e.append;
    /**
     * -------------------------------------------------------------------
     * Masks & UI helpers --------------------------------------------------
     * -------------------------------------------------------------------
     */
    var nextStep = useStepper().nextStep;
    var isMobile = useIsMobile();
    var modality = useCollectiveModalityStore(function (state) { return state.modality; });
    /**
     * -------------------------------------------------------------------
     * Handlers ------------------------------------------------------------
     * -------------------------------------------------------------------
     */
    function handleAddTechnician() {
        append({
            cpf: "",
            rg: "",
            nome: "",
            data_nascimento: "",
            foto_arquivo: undefined,
        });
    }
    useEffect(function () {
        if (fields.length === 0) {
            append({
                cpf: "",
                rg: "",
                nome: "",
                data_nascimento: "",
                foto_arquivo: undefined,
            });
        }
    }, [append, fields.length]);
    /**
     * -------------------------------------------------------------------
     * Render --------------------------------------------------------------
     * -------------------------------------------------------------------
     */
    return (_jsx(FormProvider, __assign({ handleSubmit: handleSubmit, register: register, watch: watch, formState: __assign({ errors: errors }, formStateRest), control: control }, formRest, { children: _jsxs("form", __assign({ className: "w-full flex flex-col space-y-12", onSubmit: handleSubmit(function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log(data);
                            return [4 /*yield*/, onSubmit(data)];
                        case 1:
                            _a.sent();
                            nextStep();
                            return [2 /*return*/];
                    }
                });
            }); }) }, { children: [_jsxs("div", __assign({ className: "flex flex-col space-y-8 py-8" }, { children: [isMobile && (_jsx("div", __assign({ className: "flex justify-start" }, { children: _jsx(Stepper.Radial, { size: 70, weight: 5 }) }))), _jsx("span", __assign({ className: "text-sm font-semibold text-[#022A59]" }, { children: modality })), fields.map(function (field, index) {
                            var _a, _b, _c, _d, _e, _f;
                            return (_jsxs("div", __assign({ className: "flex flex-col space-y-8" }, { children: [_jsx("span", __assign({ className: "text-sm font-semibold text-[#022A59]" }, { children: "Dados do estudante-atleta ".concat(index + 1) })), _jsx("div", __assign({ className: "grid grid-cols-1 md:grid-cols-2 gap-4" }, { children: _jsx(AthleteFields, { errors: errors, index: index, 
                                            // @ts-ignore
                                            register: register }) })), _jsx("span", __assign({ className: "mb-7 text-sm font-semibold text-[#022A59]" }, { children: "Envio da foto do estudante-atleta ".concat(index + 1) })), _jsx(FileInput, __assign({ label: "Foto", 
                                        /**
                                         * O FileInput exibe a miniatura da foto se existir um valor
                                         * padrão. No fluxo de edição, "defaultValues" cobre isso,
                                         * no fluxo de criação, não há valor.
                                         */
                                        accept: ".jpg,.png", defaultValue: (_c = (_b = (_a = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.alunos_atletas) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.foto_arquivo) === null || _c === void 0 ? void 0 : _c[0] }, register("alunos_atletas.".concat(index, ".foto_arquivo")), { 
                                        // @ts-ignore
                                        error: (_f = (_e = (_d = errors.alunos_atletas) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.foto_arquivo) === null || _f === void 0 ? void 0 : _f.message }))] }), field.id));
                        }), _jsxs("button", __assign({ type: "button", className: "flex justify-center items-center gap-1 self-end font-semibold text-sm text-[#022A59] border-blue-900", onClick: handleAddTechnician }, { children: [_jsx(Icon, { name: "Plus", size: 20 }), "Adicionar outro estudante-atleta"] }))] })), _jsx(FormActions, {})] })) })));
}
